var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AtomButtonLink',{class:_vm.css(),attrs:{"type":_vm.AtomButtonLinkTypeEnum.SECONDARY,"route":{
    name: 'reports.index',
    params: _vm.businessId,
  }}},[_c('AtomIcon',{class:_vm.css('icon'),attrs:{"name":"reports","size":21}}),_vm._v(" "+_vm._s(_vm.t("label.reports"))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }